"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var Procedure_1 = require("./Procedure");

var types_1 = require("../types");

var PolymathError_1 = require("../PolymathError");
/**
 * Procedure that modifies the maximum amount of holders for the security token
 */


var ModifyMaxHolderCount =
/*#__PURE__*/
function (_Procedure_1$Procedur) {
  _inherits(ModifyMaxHolderCount, _Procedure_1$Procedur);

  function ModifyMaxHolderCount() {
    var _this;

    _classCallCheck(this, ModifyMaxHolderCount);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ModifyMaxHolderCount).apply(this, arguments));
    _this.type = types_1.ProcedureType.ModifyMaxHolderCount;
    return _this;
  }
  /**
   * Sets the maximum amount of holders for the security token
   *
   * Note that this procedure will fail if the security token symbol doesn't exist
   * Note that this procedure will fail if the security token has disabled the TokenholderCountRestrictions feature
   */


  _createClass(ModifyMaxHolderCount, [{
    key: "prepareTransactions",
    value: function prepareTransactions() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this$args, symbol, maxHolderCount, contractWrappers, countTransferManagerModule;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$args = this.args, symbol = _this$args.symbol, maxHolderCount = _this$args.maxHolderCount;
                contractWrappers = this.context.contractWrappers;
                _context.prev = 2;
                _context.next = 5;
                return contractWrappers.tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 5:
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](2);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "There is no Security Token with symbol ".concat(symbol)
                });

              case 10:
                _context.next = 12;
                return contractWrappers.getAttachedModules({
                  moduleName: contract_wrappers_1.ModuleName.CountTransferManager,
                  symbol: symbol
                }, {
                  unarchived: true
                });

              case 12:
                countTransferManagerModule = _context.sent[0];

                if (countTransferManagerModule) {
                  _context.next = 15;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: 'You must enable the TokenholderCountRestrictions Feature'
                });

              case 15:
                _context.next = 17;
                return this.addTransaction(countTransferManagerModule.changeHolderCount, {
                  tag: types_1.PolyTransactionTag.ChangeHolderCount
                })({
                  maxHolderCount: maxHolderCount
                });

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 7]]);
      }));
    }
  }]);

  return ModifyMaxHolderCount;
}(Procedure_1.Procedure);

exports.ModifyMaxHolderCount = ModifyMaxHolderCount;